import owd from 'owd/owd';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

export default class Member extends owd.Component {
	init() {
		this.updateUseLock();
        this.bind();
	}

	updateUseLock() {
		this.useLock = !!window.matchMedia('(min-width: 768px)').matches;
	}

	bind() {
		this.on('resize', this.dom.$window, () => {
			this.updateUseLock();

			if (!this.useLock && $('.has-modal-open').length) {
				enableBodyScroll(this.$element[0]);
			}
		});

		this.on('click', this.$element.find('[data-member-open]'), (e) => {
			const $member = $(e.currentTarget).closest('[data-member]');
			$member.toggleClass('has-modal-open');
			
			if ($member.hasClass('has-modal-open')) {
				if (this.useLock) {
					disableBodyScroll(this.$element[0], {
						reserveScrollBarGap: true
					});
				}
			} else {
				enableBodyScroll(this.$element[0]);
			}
		})

		this.on('click', this.$element.find('[data-member-close]'), (e) => {
			$(e.currentTarget).closest('[data-member]').removeClass('has-modal-open');
			enableBodyScroll(this.$element[0]);
		})
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('member', {
	component: Member
});
